import { gql } from 'graphql-request'

export default gql`
  mutation registerMedicalEquipmentNoEquipment($provider: String) {
    applications {
      medicalEquipment {
        registerNoEquipment(provider: $provider) {
          success
          registered
        }
      }
    }
  }
`
